
export const colors = ["blue", "orange", "yellow", "purple", "dark_green"];